module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/poster-7-6c4a6f1fcaa38236262780321448b52f.jpg";